import {i18n} from './i18n'
import { Dialog, Toast } from 'vant'
import config from '@/config'
import load from '@/utils/fangcloud-loader'
import { USER_GUIDE_SETTING, LOG_ACTION } from '@/config/api'
import ajax from './ajax'
import CryptoJS from 'crypto-js'
import { fileTypeIconMaps } from '@/utils/fileUtils'

export function formatDate (d, format, noHourMinute, todayMinute) {
  if (typeof (d) !== 'object') {
    d = new Date(d)
  }
  const mon = d.getMonth() + 1
  const day = d.getDate()
  const hour = d.getHours()
  const minute = d.getMinutes()
  const second = d.getSeconds()

  format = format || '%R'

  if (format === '%R') {
    let currentTime = new Date()
    let todayStart = new Date()
    todayStart.setHours(0, 0, 0, 0)
    let diffSeconds = Math.floor((todayStart.getTime() - d.getTime()) / 1000)
    if (diffSeconds <= 0) {
      diffSeconds = Math.floor((currentTime.getTime() - d.getTime()) / 1000)
      if (todayMinute) {
        format = '%hh:%mm'
      } else if (diffSeconds <= 0) {
        format = i18n.t('base.time.justNow')
      } else if (diffSeconds < 60) {
        format = i18n.t('base.time.beforeSeconds', [diffSeconds])
      } else if (diffSeconds < 60 * 60) {
        format = i18n.t('base.time.beforeMinutes', [Math.floor(diffSeconds / 60)])
      } else if (diffSeconds < 60 * 60 * 24) {
        format = i18n.t('base.time.beforeHours', [Math.floor(diffSeconds / 60 / 60)])
      }
    } else {
      if (diffSeconds <= 60 * 60 * 24) {
        format = i18n.t('base.time.yesterday')
      } else if (diffSeconds <= 60 * 60 * 48) {
        if (i18n.locale === 'en') {
          format = '%MM-%DD'
        } else {
          format = i18n.t('base.time.theDayBefore')
        }
      } else {
        format = '%MM-%DD'
        if (d.getFullYear() !== todayStart.getFullYear()) {
          format = '%YY-' + format
        }
      }

      if (!noHourMinute) {
        format += ' %hh:%mm'
      }
    }
  }

  if (format === '%L') {
    let currentTime = new Date()
    const diffSeconds = Math.floor((d.getTime() - currentTime.getTime()) / 1000)
    if (diffSeconds <= 86400) {
      if (diffSeconds <= 0) {
        format = ''
      } else if (diffSeconds < 60) {
        format = i18n.t('unit.second', [diffSeconds])
      } else if (diffSeconds < 60 * 60) {
        format = i18n.t('unit.minute', [Math.floor(diffSeconds / 60)])
      } else if (diffSeconds < 60 * 60 * 24) {
        format = i18n.t('unit.hour', [Math.floor(diffSeconds / 60 / 60)])
      }
    } else if (diffSeconds <= 691200) {
      format = i18n.t('unit.day', [Math.floor(diffSeconds / 86400)])
    } else {
      format = '%YY-%MM-%DD'
    }
  }

  return format
    .replace('%YY', d.getFullYear())
    .replace('%Y', d.getFullYear() % 100)
    .replace('%MM', mon < 10 ? '0' + mon : mon)
    .replace('%M', mon)
    .replace('%DD', day < 10 ? '0' + day : day)
    .replace('%D', day)
    .replace('%hh', hour < 10 ? '0' + hour : hour)
    .replace('%h', hour)
    .replace('%mm', minute < 10 ? '0' + minute : minute)
    .replace('%m', minute)
    .replace('%ss', second < 10 ? '0' + second : second)
    .replace('%s', second)
}

// size multiples approximation
export function approxSize (nBytes, unit, digits = 2) {
  let defaultMark = false
  if (digits === 2) {
    defaultMark = true
  }
  const quo = unit ? 0 : 1024
  const aMultiples = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const multiples_max = aMultiples.length - 1
  let nMultiple, nApprox
  for (nMultiple = 0, nApprox = nBytes - 0; nMultiple < multiples_max && nApprox >= quo; nApprox /= 1024, nMultiple++) {
    if (unit === aMultiples[nMultiple]) {
      break
    }
  }
  if (defaultMark && nMultiple <= 1) {
    // 默认情况下去除B和KB的小数位
    digits = 0
  }
  return nApprox.toFixed(digits) + (unit ? '' : (' ' + aMultiples[nMultiple]))
}

export function alert (options) {
  if (typeof options === 'string') {
    return Dialog.alert({
      message: options,
      confirmButtonText: i18n.t('base.know')
    })
  } else {
    Object.assign(options, {
      confirmButtonText: i18n.t('base.know')
    })
    return Dialog.alert(options)
  }
}

export function confirm (options) {
  if (typeof options === 'string') {
    return Dialog.confirm({
      message: options
    })
  } else {
    options = Object.assign({
      confirmButtonText: i18n.t('base.confirm'),
      cancelButtonText: i18n.t('base.cancelText')
    }, options)

    return Dialog.confirm(options)
  }
}

export const toast = Toast

toast.success = function (msg) {
  toast({
    type: 'html',
    message: `<i class="iconfont icon-success"></i><div class="text">${msg}</div>`
  })
}

toast.fail = function (msg) {
  toast({
    type: 'html',
    message: `<i class="iconfont icon-fail"></i><div class="text">${msg}</div>`
  })
}

export const loading = function (msg = i18n.t('base.loading')) {
  return Toast.loading({
    mask: true,
    duration: 0,
    message: msg
  })
}

export const loadingWithoutUserInterface = function () {
  return Toast.loading({
    duration: 0,
    forbidClick: true
    // loadingType: 'spinner'
  })
}

const tagsToReplace = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;'
}

export const stripTags = function (str) {
  return str.replace(/[&<>"]/g, function (tag) {
    return tagsToReplace[tag] || tag
  })
}

export const escapeHTML = function (str, newlineReplace = '<br/>') {
  str = stripTags(str)
  str = str.replace(/&lt;span\s+class=&quot;highlight&quot;&gt;(.*?)&lt;\/span&gt;/g, function (match, p1) {
    return '<span class="highlight">' + p1 + '</span>'
  })
  str = str.replace(/(\r\n|\n|\r)/gm, newlineReplace)
  return str
}

export function addClass (el, cls) {
  if (!el) return
  let curClass = el.className
  const classes = (cls || '').split(' ')

  for (let i = 0, j = classes.length; i < j; i++) {
    const clsName = classes[i]
    if (!clsName) continue

    if (el.classList) {
      el.classList.add(clsName)
    } else {
      if (!hasClass(el, clsName)) {
        curClass += ' ' + clsName
      }
    }
  }
  if (!el.classList) {
    el.className = curClass
  }
}

const trim = function (string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '')
}

export function hasClass (el, cls) {
  if (!el || !cls) return false
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.')
  if (el.classList) {
    return el.classList.contains(cls)
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1
  }
}

/* istanbul ignore next */
export function removeClass (el, cls) {
  if (!el || !cls) return
  const classes = cls.split(' ')
  let curClass = ' ' + el.className + ' '

  for (let i = 0, j = classes.length; i < j; i++) {
    const clsName = classes[i]
    if (!clsName) continue

    if (el.classList) {
      el.classList.remove(clsName)
    } else {
      if (hasClass(el, clsName)) {
        curClass = curClass.replace(' ' + clsName + ' ', ' ')
      }
    }
  }
  if (!el.classList) {
    el.className = trim(curClass)
  }
}

export const getQueryString = (params, allowEmptyValue, encode = true) => {
  let esc = encodeURIComponent
  let ret = []
  if (!encode) { esc = val => val }
  Object.keys(params).forEach(k => {
    let val = params[k]
    if (typeof val !== 'undefined') {
      ret.push(`${esc(k)}=${esc(val)}`)
    } else if (allowEmptyValue) {
      ret.push(`${esc(k)}`)
    }
  })
  return ret.join('&')
}

export const getQueryStringValue = (key) => {
  return decodeURIComponent(window.location.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[.+*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'))
}

export const endsWith = function (str, searchStr, position) {
  // This works much better than >= because
  // it compensates for NaN:
  if (!(position < str.length)) {
    position = str.length
  } else {
    position |= 0 // round position
  }
  return str.substr(position - searchStr.length,
    searchStr.length) === searchStr
}

export function mention (str, metionAllString) {
  const re = /@\[(?:g-)?(\d+):([^\]]+)\]/g
  return escapeHTML(str).replace(re, function (match, p1, p2) {
    if (p1 === '0') {
      if (typeof metionAllString === 'string') {
        p2 = metionAllString
      } else {
        p2 = i18n.t('file.comment.metionAll')
      }
    }
    return '<a class="mention" href="javascript:;">@' + p2 + '</a>'
  })
}

export function getDefaultDueTime () {
  const defaultExpiringDays = parseInt(config.enterprise_info.default_expiring_interval_days, 10)
  let defaultDueTime = defaultExpiringDays ? new Date(Date.now() + defaultExpiringDays * 24 * 60 * 60 * 1000) : 0
  if (defaultDueTime) {
    defaultDueTime.setHours(23)
    defaultDueTime.setMinutes(59)
    defaultDueTime.setSeconds(59)
    defaultDueTime = parseInt(defaultDueTime / 1000)
  }
  return defaultDueTime
}

const agent = navigator.userAgent.toLowerCase()
const regStr = /(os|android) [\d._]*/gi
const verinfo = agent.match(regStr)
const version = (verinfo + '').replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.')

export const ua = {
  iOS: /iphone|ipad|ipod/.test(agent),
  Android: /android/.test(agent),
  qq: /qq\//.test(agent), // qq内置浏览器会有：'qq/xxx'
  wechat: (/micromessenger/.test(agent)) && (!(/wxwork/.test(agent))),
  version,
  wxworkPC: !/iphone|ipad|ipod|android/.test(agent) && /wxwork/.test(agent),
  wxworkH5: /iphone|ipad|ipod|android/ && /wxwork/.test(agent),
  wxwork: /wxwork/.test(agent),
  dingtalk: /dingtalk/.test(agent),
  fengyun: /mideaconnect/.test(agent)
}
export const encodeHTML = (text) => text.replace(/&/g, '&amp').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

let domain_array = window.location.hostname.split('.')
export const domain = domain_array.slice(1).join('.')

export const sortByMap = {
  date_asc: 'file.sort.dateAsc',
  date_desc: 'file.sort.dateDesc',
  name_asc: 'file.sort.nameAsc',
  name_desc: 'file.sort.nameDesc',
  size_asc: 'file.sort.sizeAsc',
  size_desc: 'file.sort.sizeDesc'
}

export const fileViewReservedQuery = ['comment', 'preview', 'file_id', 'scenario', 'folder_id', 'wps_edit', 'filenav', 'version', 'unique_name', 'share_extension_category']

// wechat
let _pageShare = {}
// loadJweixinIfNeeded 需要在is_from_wechat_enterprise请求回来以后执行
export function loadJweixinIfNeeded () {
  console.log('before load jweixin-sdk')
  if (_pageShare.isLoadSDK) return
  if (ua.wechat || (ua.wxwork && config.is_from_wechat_enterprise)) {
    Object.assign(_pageShare, {isLoadSDK: true})
    let loadsdk = load.js('//res.wx.qq.com/open/js/jweixin-1.4.0.js')
    let loadCallback = () => {
      /********************************
       * options:
       * title 分享标题
       * link 分享链接
       * imgUrl 分享图标
       * success {Function}
       * cancel {Function}
       * desc {String}, (微信朋友,QQ,QQWeibo,QZone) 分享描述
       * type {String}, (只有分享给微信朋友时有用) 分享类型,music、video或link，不填默认为link
       * dataUrl {Url}, (只有分享给微信朋友时有用) 如果type是music或video，则要提供数据链接，默认为空
       ********************************/
      Object.assign(_pageShare, {
        // 用来保存微信、企业微信当前配置的URL路径
        currentWXConfigLocation: '',
        waitting: [],
        readyLocations: [],
        isJsApiChecked: false,
        currentLocation () {
          // FileView下对location.query处理过，这里也需要处理下
          var currentLocation = window.location.href.split('#')[0]
          return currentLocation
        },
        shareAll (data, options) {
          // 微信内添加分享相关的菜单按钮
          const accept_share_action = options && options.accept_share_action
          let current_data = Object.assign({}, data)
          for (let i in _pageShare) {
            if (typeof (_pageShare[i]) === 'function' && ['shareTimeline', 'shareAppMessage', 'shareWechat'].includes(i)) {
              try {
                if (accept_share_action && accept_share_action[i]) {
                  current_data = accept_share_action[i](current_data)
                }
                current_data && _pageShare[i](current_data)
              } catch (e) { }
            }
          }

          setTimeout(() => {
            // 从企业微信内分享到【微信、企业微信】
            const callback = options && options.callback

            // 从企业微信内分享到【微信、企业微信】
            const share_action_category = options && options.share_action_category
            if (ua.wxwork && typeof (share_action_category) === 'string' && ['Wechat', 'EnterpriseWechat'].includes(share_action_category)) {
              Toast.clear()
              try {
                // 分享到企业微信内的会话
                if (current_data && share_action_category === 'EnterpriseWechat') {
                  window.wx.invoke('shareAppMessage', current_data, function (res) {
                    if (res.err_msg === 'shareAppMessage:ok') {
                      // toast.success('成功分享到企业微信')
                      // console.log('成功分享到企业微信')
                    }
                    callback && callback()
                  })
                }
                // 分享到微信
                if (current_data && share_action_category === 'Wechat') {
                  window.wx.invoke('shareWechatMessage', current_data, function (res) {
                    if (res.err_msg === 'shareWechatMessage:ok') {
                      // toast.success('成功分享到微信')
                      // console.log('成功分享到微信')
                    }
                    callback && callback()
                  })
                }
              } catch (e) { }
            }
          }, 500)
        },
        auth () {
          const url = ua.wxwork ? '/third_party/qy_wechat/signature' : '/third_party/wechat/signature'
          // 这里【位置1】取到的url一定得与【位置2】取到的url保持一致
          // url是用在计算签名时候用的，我们计算的签名，需要与企业微信计算的签名一直才有效.
          // 这里【位置1】取到的的url是传给服务端计算签名用的； 企业微信计算的签名是在【位置2】进行wx.config时，企业微信自己取到的；
          // 如果企业微信在Debug模式下，报 invalid signature 的错误，请打开【位置1】【位置2】下方的console.log查看url输出是否一致。
          console.log('current.url.beforeSignature', window.location.href.split('?')[0].split('#')[0])
          // 注意：初次进入h5页面时，位置1取到的url带参数，真正wx.config时是不带参数的，导致签名不一致，这里去掉url后的参数
          let current_location = _pageShare.currentLocation()
          _pageShare.currentWXConfigLocation = current_location
          ajax({
            url,
            data: {
              url: current_location
            },
            accept_all_errors: true
          }).then(res => {
            if (res && res.success) {
              let response = res.response

              // console.log('response', response)

              // 这里【位置2】取到的url一定得与【位置1】取到的url保持一致
              // url是用在计算签名时候用的，我们计算的签名，需要与企业微信计算的签名一直才有效.
              // 这里【位置2】取到的的url是企业微信用来计算签名用的，我们无法确认，只能在这里通过日志判断
              // 如果企业微信在Debug模式下，报 invalid signature 的错误，请打开【位置1】【位置2】下方的console.log查看url输出是否一致。
              console.log('current.url.afterSignature.beforeConfig', window.location.href.split('?')[0].split('#')[0])
              // 保存当前正在配置的路径 并状态清空
              if (current_location !== _pageShare.currentLocation()) {
                setTimeout(() => {
                  _pageShare.auth()
                }, 0.1)
                return
              }
              window.wx.config({
                debug: false,
                beta: true,
                appId: response.appid,
                timestamp: response.timestamp,
                nonceStr: response.noncestr,
                signature: response.signature,
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareWechat', 'shareWechatMessage', 'shareAppMessage']
              })
            }
          })
        },
        authIfNeeded () {
          // 1.检查当前路径是否配置过
          let location = _pageShare.currentLocation()
          if (!this.readyLocations.includes(location) && _pageShare.currentWXConfigLocation !== location) {
            // 2.配置授权ready的回调
            window.wx && window.wx.ready(() => {
              if (!_pageShare.readyLocations.includes(location)) {
                _pageShare.readyLocations.push(location)
              }

              // 处理微信的相关接口
              if (!_pageShare.isJsApiChecked) {
                Object.assign(_pageShare, {
                  // 分享到朋友圈
                  shareTimeline (data) {
                    window.wx.onMenuShareTimeline(data)
                  },
                  // 分享给朋友
                  shareAppMessage (data) {
                    window.wx.onMenuShareAppMessage(data)
                  },
                  // 分享给微信
                  shareWechat (data) {
                    window.wx.onMenuShareWechat(data)
                  }
                })
              }
              // 记录是否来自企业微信
              var is_wxwork = false
              if (ua.wxwork) is_wxwork = true
              Object.assign(_pageShare, {
                is_wxwork: is_wxwork
              })
              // 执行未完成的分享操作
              const waitting = _pageShare.waitting
              for (let i = 0; i < waitting.length; i++) {
                waitting[i](_pageShare)
              }

              // 企业微信内调用 记录一下当前支持的操作
              if (ua.wxwork && !_pageShare.isJsApiChecked) {
                window.wx && window.wx.checkJsApi({
                  jsApiList: ['shareAppMessage', 'shareWechatMessage'], // 需要检测的JS接口列表
                  success: function (res) {
                    // 以键值对的形式返回，可用的api值true，不可用为false
                    // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                    const checkResult = res && res['checkResult']
                    if (checkResult) {
                      let isSupportShareAppMessage = checkResult['shareAppMessage']
                      let isSupportShareWechatMessage = checkResult['shareWechatMessage']
                      Object.assign(_pageShare, {
                        // 是否来自企业微信
                        is_wxwork: true,
                        // 支持分享到企业微信会话
                        is_support_shareAppMessage: (typeof (isSupportShareAppMessage) === 'boolean' && isSupportShareAppMessage),
                        // 支持分享到微信
                        is_support_shareWechatMessage: (typeof (isSupportShareWechatMessage) === 'boolean' && isSupportShareWechatMessage)
                      })
                      _pageShare.isJsApiChecked = true
                    }
                  }
                })
              }
            })

            window.wx && window.wx.error(function (res) {
              _pageShare.currentWXConfigLocation = ''
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
              console.log(res)
            })
            // 3.进行配置
            _pageShare.auth()
          }
        },
        isReadyForCurrentLocation () {
          let currentLocation = _pageShare.currentLocation()
          return _pageShare.readyLocations.includes(currentLocation)
        },
        ready (callback) {
          // 当前location已经wx.config完成
          if (_pageShare.isReadyForCurrentLocation()) {
            callback(_pageShare)
          } else {
            if (_pageShare.waitting.length > 0) {
              _pageShare.waitting.splice(0, this.waitting.length)
            }
            _pageShare.waitting.push(callback)
            _pageShare.authIfNeeded()
          }
        }
      })
    }
    // 如果不成功，后面再试
    loadsdk.then(_ => {
      console.log('load微信sdk成功')
      loadCallback()
      _pageShare.authIfNeeded && _pageShare.authIfNeeded()
    }).catch(_ => {
      console.log('load微信sdk失败，1s后再试')
      setTimeout(() => {
        loadJweixinIfNeeded()
      }, 1000)
    })
  }
}

export const pageShare = window.pageShare = _pageShare
export const updateUserGuideSetting = (data) => {
  return ajax({
    url: USER_GUIDE_SETTING,
    data: { new_user_guide_settings: data },
    accept_all_errors: true
  })
}

export const deepCopy = (obj) => {
  if (obj === null) return null
  const result = Array.isArray(obj) ? [] : {}
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object') {
        result[key] = deepCopy(obj[key])
      } else {
        result[key] = obj[key]
      }
    }
  }
  return result
}

export function loadDingTalkIfNeeded () {
  if (ua.dingtalk && !window.dd) {
    load.js('https://g.alicdn.com/dingding/dingtalk-jsapi/2.13.3/dingtalk.open.js').then(_ => {
      setDocumentTitle(document.title)
    })
  } else if (window.dd) {
    setDocumentTitle(document.title)
  }
}

export function loadFengyunIfNeeded (initCordova) {
  const flatform = ua.iOS ? 'ios' : 'android'
  if (ua.fengyun) {
    load.js((process.env.ASSETS_URL ? process.env.ASSETS_URL : '/') + 'h5assets/' + flatform + '/cordova.js').then(_ => {
      console.log('load.js')
      /* 启动cordova */
      initCordova()
    })
  }
}

export function setDocumentTitle (title) {
  // 设置 document title
  document.title = title

  // 钉钉内 主动调用 钉钉Api 设置title
  if (window.dd) {
    window.dd.biz.navigation.setTitle({
      title: document.title
    })
  }
}

export const getPageShareIcon = (item) => {
  let extension
  if (item.type === 'file') {
    if (item.extension_category === 'image') {
      extension = 'image'
    } else {
      extension = item.extension
    }
  } else if (item.type === 'folder') {
    extension = 'folder'
  } else {
    extension = 'default'
  }
  return `${config.imageUrl}/assets/app/mobile/images/typeicons/type-icons-${fileTypeIconMaps[extension] || 'default'}.png`
}

export function logRequest (data) {
  ajax({
    url: LOG_ACTION,
    data,
    accept_all_errors: true
  })
}

export function guid () {
  function s4 () {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

export function handleUploadLog (item, newFile = {}, isOpenPlatform) {
  const { uuid, uploadTarget } = item || {}
  let [target_type, target_id] = uploadTarget ? uploadTarget.split('_') : []
  if (target_id === '0') {
    target_type = 'user'
    target_id = config.user_info ? config.user_info.id : 0
  }

  const data = {
    uuid: uuid || guid(),
    action: 'upload_stat',
    source: 'h5',
    typed_id: newFile.typed_id,
    additional_info: {
      is_new_file: 1,
      upload_type: 'upload_file_btn',
      target_type,
      target_id
    }
  }

  logRequest(data)
}

export function openPlatformCallback (type, data) {
  window.parent.postMessage(JSON.stringify({ type: type, from: 'fangcloud', data }), config.openConfig.origin)
}

export function setReviewStatus (process) {
  if (!process.review || !process.review.recent_review_info) {
    return ''
  }
  let { is_valid, is_closed, review: { recent_review_info: { action, return_review_info } } } = process
  let status = 'processing'
  if (!is_valid) {
    status = 'invalid'
  } else if (is_closed) {
    status = 'closed'
  } else if (action === 1) {
    status = 'passed'
  } else if (action === 2) {
    status = 'rejected'
  } else if (return_review_info && return_review_info.action === 3) {
    status = 'returned'
  }
  return status
}

export function goToUserDetail (id) {
  // eslint-disable-next-line no-undef
  fangcloud.postMessage(JSON.stringify({method: 'contact', params: id}))
}

export const freePlanErrorMsg = {
  'exceed_plan_download_traffic_limit_true': '该月的免费下载流量已用完。请下个月再来，或升级付费套餐，立享无限流量。',
  'exceed_plan_download_traffic_limit_false': '该月的免费下载流量已用完。请下个月再来，请联系管理员升级套餐。',
  'exceed_plan_upload_traffic_limit_true': '该月的免费上传流量已用完。请下个月再来，或升级付费套餐，立享无限流量。',
  'ordinary_tip_exceed_plan_upload_traffic_limit_false': '该月的免费上传流量已用完。请下个月再来，请联系管理员升级套餐。',
  'free_plan_collab_folder_limit_true': '免费套餐协作文件夹最多为10个，请升级套餐，立享协作文件数量无限制。',
  'free_plan_collab_folder_limit_false': '免费版协作文件夹已达到上限，请联系管理员升级套餐。',
  'free_plan_exceed_space_limit_true': '空间使用已超出套餐限制，请升级套餐，立享大空间。',
  'free_plan_exceed_space_limit_false': '空间使用已达到上限，请联系管理员升级套餐。'
}

const getTs = async () => {
  const result = await ajax({
    url: '/hermes/ts',
    type: 'GET',
    accept_all_errors: true
  })
  console.log('result', result)
  if (result && result.success) {
    return result.data.server_time
  }
  return ''
}

let captcha = null

export const initSlidingCaptcha = (onSuccess, params) => {
  if (document.getElementById('aliyunCaptcha-mask')) {
    document.getElementById('aliyunCaptcha-mask').remove()
  }
  if (document.getElementById('aliyunCaptcha-window-popup')) {
    document.getElementById('aliyunCaptcha-window-popup').remove()
  }
  window.initAliyunCaptcha({
    SceneId: '1evkf18n', // 线上ID：'1evkf18n', 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
    prefix: '1ss4h8', // 线上prefix：'1ss4h8', 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
    mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
    element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
    button: '#captcha-button', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
    captchaVerifyCallback: captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
    onBizResultCallback: onBizResultCallback, // 业务请求结果回调函数，无需修改
    getInstance: getInstance, // 绑定验证码实例函数，无需修改
    slideStyle: {
      width: 360,
      height: 40
    }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
    language: 'zh-CN', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
    region: 'cn' // 验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）、海外（ga）
  })

  // 绑定验证码实例函数。该函数为固定写法，无需修改
  function getInstance (instance) {
    captcha = instance
    captcha.show()
  }

  async function captchaVerifyCallback (captchaVerifyParam) {
    const _captchaVerifyParam = JSON.parse(captchaVerifyParam)
    const ts = await getTs()
    const md5_key = `sceneId=${_captchaVerifyParam.sceneId}&certifyId=${_captchaVerifyParam.certifyId}&ts=${ts}&security=dd1393a2feba4b3bb98505f1c61527ce`
    const signature = CryptoJS.MD5(md5_key).toString()
    // 1.向后端发起业务请求，获取验证码验证结果和业务结果
    const res = await ajax({
      url: '/hermes/captcha_verify',
      data: {
        captcha_verify_param: captchaVerifyParam,
        signature: signature,
        region: 'cn',
        ts: ts
      },
      accept_all_errors: true
    })
    const {success, data = {}, code, msg} = res || {}
    if (success && data && data.verify_result) {
      onSuccess && onSuccess({request_id: data.request_id})
      return {captchaResult: true}
    } else {
      if (code === 'verify_operation_too_frequent') {
        toast({
          content: msg
        })
      }
      return {captchaResult: false}
    }
  }

  // 业务请求验证结果回调函数
  function onBizResultCallback (bizResult) {
    // 此处拿不到captchaVerifyParam信息所以这里什么都不处理
    // if (bizResult === true) {
    //     // onSuccess && onSuccess(bizResult);
    // } else {
    //     // 如果业务验证不通过，给出不通过提示。此处不通过提示为业务验证不通过！
    //     alert('业务验证不通过！');
    // }
  }
}
